/**
 * Paths where analytics, feature flags, and service-worker interception
 * must not block or interfere with sign-in flows.
 */
export function isAuthRoutePath(pathname: string): boolean {
  if (!pathname) return false;
  if (pathname === "/login" || pathname.startsWith("/login/")) return true;
  if (pathname.startsWith("/auth/")) return true;
  if (pathname.startsWith("/api/auth/")) return true;
  if (pathname === "/admin-login" || pathname.startsWith("/admin-login/")) return true;
  return false;
}
